import {useApp} from '@components/providers/app-provider';
import Link from 'next/link';

const ImportStatusModal = ({show}: {show: boolean}) => {
  const {setImportModalOpen} = useApp();

  return (
    <div>
      <div className={show ? 'block modal fade show ' : 'fade modal hidden'}>
        <div className="modal-dialog   ">
          <div className="modal-content max-w-[850px] max-h-[599px] lg:w-[805px] lg:h-[566px] md:w-[425px] md:h-[566px] sm:w-[400px] sm:h-[599px] mbl:w-[360px] mbl:h-[599px] ">
            <div className=" flex items-center justify-center flex-col py-6">
              <div className="lg:py-6 mbl:py-10 mbl:mt-10">
                <Link href="/">
                  <a className="shrink-0 lg:mr-14 ">
                    <img
                      src="/images/logo-dark.png"
                      className=" lg:w-[278px] lg:h-[60px] mbl:w-[219px] mbl:h-[44px]"
                      alt="Nusa | NFT Marketplace"
                    />
                  </a>
                </Link>
              </div>

              <div className="w-full max-w-[27.625rem] max-h-full text-center px-2 pt-8 lg:mt-0 mbl:mt-2">
                <h1 className="text-jacarta-700 font-display mb-6 lg:text-4xl mbl:text-2xl dark:text-white">
                  Import on progress
                </h1>
                <p className="dark:text-jacarta-300 mb-10 lg:text-[20px] mbl:text-base mbl:leading-5  ">
                  Your collection is being indexed. Please come back to this page later to see your
                  items.{' '}
                </p>
                <div className="flex justify-around gap-5">
                  <Link href="/collection/import">
                    <button
                      onClick={() => setImportModalOpen(false)}
                      className="dark:bg-dark-grey bg-white dark:border-grey border-jacarta-100 text-jacarta-700 mb-4 flex w-1/2 h-[40px] items-center justify-center rounded-full border-2 py-4 text-center font-semibold hover:bg-gradient-to-br dark:hover:bg-gradient-to-br from-green-3 to-green-2  hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent "
                    >
                      Back to import
                    </button>
                  </Link>
                  <button
                    onClick={() => setImportModalOpen(false)}
                    className="dark:bg-dark-grey bg-white dark:border-grey border-jacarta-100 text-jacarta-700 mb-4 flex w-1/2 h-[40px] items-center justify-center rounded-full border-2 py-4 text-center font-semibold hover:bg-gradient-to-br dark:hover:bg-gradient-to-br from-green-3 to-green-2  hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent "
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportStatusModal;
